import { Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  SectionStack,
} from "./HelpDialogLayout";

export interface RoomLightDialogProps extends HelpDialogLayoutProps {}
export default function RoomLightDialog(props: RoomLightDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">
            就寝前の部屋の明かりの睡眠への影響
          </Typography>
          <BodyTypographies
            contents={[
              "多くの人が「寝るときは電気を消す」習慣を持っているのではないでしょうか。",
              "就寝中の部屋の明かりも重要ですが、実は、”寝る前”の光も睡眠に影響を与えます。",
              "眠気をつかさどるメラトニンというホルモンがありますが、メラトニンは就寝タイミングの2時間前くらいから分泌が始まり、睡眠を促していきます。しかし、そのタイミングで強い光を浴びてしまうと、メラトニンの分泌が抑制されてしまい、眠気が起こらず寝付きを阻害することが知られています。また光の色調としては、朝日に近い白色のものよりも、夕日に近い暖色のものの方が睡眠への影響が少ないと言われています。",
            ]}
          />
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">おすすめの部屋の明かり</Typography>
          <BodyTypographies
            contents={[
              "就寝前：",
              "就寝1時間前には白色照明を控え、暖色照明・間接照明等で部屋の明かりを半分ほどに抑えましょう。最近の照明は調光機能がついているものも多いため、明るさを抑えたモードに切り替えるのもおすすめです。",
              "また、コンビニ等明るい場所には夜行かないようにしましょう。",
              "",
              "就寝中：",
              "寝ている間の部屋の明かりについては、できる限り真っ暗が望ましいです。",
              "睡眠に適した明るさが0.1～0.2ルクスに対し、豆電球などの小さい光でも3～9ルクスあるため、光の影響を受けやすい方は、目に入ると寝付きを遅らせたり睡眠の質を低下させたりする影響があることが知られています。おすすめの対応方法は、例えば、屋外の街灯が入る場合は遮光カーテンにする、エアコンやルーターなどの電子機器の明かりが強い場合は黒いテープで隠す、パートナーが明かりを必要とする場合は自分はアイマスクをするなど工夫をしてみましょう。",
              "真っ暗にすると不安な場合や転倒防止などのためにはフットライトなどを利用して目の位置よりも下に光がくるようにすると良いでしょう。",
            ]}
          />
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
